const loginByEmailAPI = () => 'api/auth/login';

const crossLoginAPI = () => 'api/auth/cross-login';

const registerDeviceTokenAPI = () => 'api/auth/device-token';

const forgotPasswordAPI = () => 'api/auth/forgot-password';

const resetPasswordAPI = () => 'api/auth/reset-password';

const acceptInviteAPI = () => 'api/auth/accept-invitation';

const setPasswordAPI = () => 'api/auth/set-password';

const updatePasswordAPI = () => 'api/auth/update-password';

const logoutAPI = () => 'api/auth/logout';

/**
 * @deprecated use fetchSession featureFlagsMap instead
 */
const getFeatureFlags = () => 'api/system/flags';

export const authEndpoints = {
  loginByEmailAPI,
  crossLoginAPI,
  registerDeviceTokenAPI,
  forgotPasswordAPI,
  resetPasswordAPI,
  acceptInviteAPI,
  setPasswordAPI,
  updatePasswordAPI,
  getFeatureFlags,
  logoutAPI,
};
